import { useEffect, useRef, useState } from 'react';
import { useNavigate } from 'react-router-dom';

//Primereact components
import { Toast } from 'primereact/toast';
import { Button } from 'primereact/button';
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import { InputText } from 'primereact/inputtext';
import { Toolbar } from 'primereact/toolbar';
import { LetterShowClick, RHUSLetterValidate } from '../../../../config/Validate';
import { defaultPageRowOptions, defaultRowOptions, SkeletonbodyTemplate, Skeletonitems } from '../../../../appconfig/Settings';
import { getAllDetailsDirect, getSpecificDetailsById, postAllData } from '../../../../service/ProductService';
import { DOWNLOADRUHSLETTER, RUHSLETTER, STORERUHSLETTER } from '../../../../config/ApiConstant';
import { AddRHUSLetterListColumns } from '../../../../appconfig/DatatableSetting';
import { amountTemplate, dateTemplate } from '../../../../appconfig/DatatableTemplateSetting';
import { VerificationTab } from '../VerificatuionTab';
import { LettersTab } from '../../LettersTab';
import Loader from '../../../../components/Loadeer/Loader';

export const RHUSLetter = () => {
    document.title = 'RHUS Verification Letter | GSPC';

    //Set Toast/ Filter Properties
    const toast = useRef<any>(null);
    const [globalFieldFilter, setGlobalFieldFilter] = useState<any>(null);
    const [globalFilter, setGlobalFilter] = useState<any>(null);

    //Loading/Page Loading
    const [pageLoad, setPageLoad] = useState<boolean>(true);
    const [errors, setErrors] = useState<any>({});
    const [regNo, setRegNo] = useState<any>(null);
    const [RHUsData, setRHUsData] = useState<any>({});
    const [addLoader, setAddLoader] = useState<boolean>(false);
    const [RHUSList, setRHUSList] = useState<any>([]);
    const [showLoading, setShowLoading] = useState<boolean>(false);
    const [loading, setLoading] = useState<boolean>(false);
    const [buttonVisible, setButtonVisible] = useState<boolean>(true);

    // useEffect
    useEffect(() => {
        getRUHSLetter();
    }, []);

    // Global search
    const leftToolbarTemplate = () => {
        return (
            <>
                <span className="search-bar mr-3">
                    <i className="pi pi-search"></i>
                    <InputText type="search" className="search-input" onInput={(e) => setGlobalFilter(e.currentTarget.value)} placeholder="Search..." />
                </span>
            </>
        );
    };

    // Right toolbar
    const rightToolbarTemplate = () => {
        return (
            <>
                <Button icon="pi pi-filter-slash" label="Clear" onClick={() => clearAllFilter()} className="p-button-outlined"></Button>
            </>
        );
    };

    //Clear All Filter
    const clearAllFilter = () => {
        setGlobalFieldFilter(null);
        setGlobalFilter(null);
    };

    // Clear all
    const clearAll = () => {
        setRegNo(null);
        setRHUsData({});
        setErrors({});
    };

    // getRUHSLetter List
    const getRUHSLetter = async () => {
        if (!window.cn(regNo)) {
            try {
                setShowLoading(true);

                const response = await getAllDetailsDirect(RUHSLETTER + '?FileNo=' + regNo + '&search=' + '');
                const { List } = response;
                if (!window.cn(response) && Object.keys(response?.Details).length !== 0) {
                    const { StudF, StudM, StudL, Passedyth } = response?.Details;
                    let FromNm = (!window.cn(StudL) ? StudL : '') + ' ' + (!window.cn(StudF) ? StudF : '') + ' ' + (!window.cn(StudM) ? StudM : '');
                    setRHUsData({
                        Name: FromNm,
                        PassYear: Passedyth
                    });
                    setRHUSList(List);
                    setShowLoading(false);
                    setButtonVisible(false);
                } else {
                    setButtonVisible(true);
                    setShowLoading(false);
                    setRHUsData({ ...RHUsData });
                }
            } catch (error: any) {
                if (error.response) {
                    //Spinner False and Set Toast

                    setShowLoading(false);
                    toast.current?.show({ severity: 'error', summary: 'Error', detail: 'Could Not Load Data' });
                }
            }
        } else {
            try {
                setPageLoad(false);
                const response = await getAllDetailsDirect(RUHSLETTER + '?search=' + '');

                if (response) {
                    const { List } = response;
                    setRHUSList(List);
                    setPageLoad(true);
                }
            } catch (error: any) {
                if (error.response) {
                    //Spinner False and Set Toast
                    setPageLoad(true);

                    toast.current?.show({ severity: 'error', summary: 'Error', detail: 'Could Not Load Data' });
                }
            }
        }
    };

    // onShowClick get User Deatsils
    const getUserDetails = async () => {
        try {
            const { errors, isError } = LetterShowClick(regNo);
            setErrors(errors);

            //Check Error if no errors then call API
            if (!isError) {
                setShowLoading(true);
                getRUHSLetter();
            }
        } catch (error: any) {
            if (error.response) {
                //Spinner False and Set Toast
                setShowLoading(false);
                toast.current?.show({ severity: 'error', summary: 'Error', detail: 'Could Not Load Data' });
            }
        }
    };

    //onchange event
    const onInputChange = (e: any, name: string) => {
        let val = (e.target && e.target.value) || e.value || '';

        setRHUsData({ ...RHUsData, [name]: val });
    };

    // Add inward data
    const addRHUsData = async () => {
        try {
            const { errors, isError } = RHUSLetterValidate(RHUsData, regNo);
            setErrors(errors);
            //Check Error if no errors then call API
            if (!isError) {
                setAddLoader(true);

                let requestData = { ...RHUsData };
                requestData['FileNo'] = Number(regNo);

                //Convert Year
                if (!window.cn(RHUsData?.PassYear)) {
                    let passed = RHUsData.PassYear.split('-');
                    RHUsData.PassYear = Number(passed[0]);
                }

                const response = await postAllData(STORERUHSLETTER, requestData);
                if (response) {
                    setAddLoader(false);
                    toast.current?.show({ severity: 'success', summary: 'Message', detail: response?.data });
                    setRHUsData({});
                    clearAll();
                    getRUHSLetter();
                }
            }
        } catch (error: any) {
            if (error.response) {
                //Spinner False and Set Toast
                setAddLoader(false);
                toast.current?.show({ severity: 'error', summary: 'Error', detail: 'Something Went Wrong' });
            }
        }
    };

    // Template for actions
    const actionsTemplate = (rowData: any) => {
        return (
            <>
                <div className="actions action-btn">
                    <Button icon="pi pi-download" onClick={() => downloadRHUSLetter(rowData?.SrNo)} tooltip="Download" tooltipOptions={{ position: 'top' }}  />
                </div>
            </>
        );
    };

    // Download bank entry
    const downloadRHUSLetter = async (id: any) => {
        try {
            setLoading(true);

            const response = await getSpecificDetailsById(DOWNLOADRUHSLETTER, id);

            //Check response and download
            if (response) {
                //PDF Download
                const { file_url } = response;
                setLoading(false);

                //PDF Download
                const fileName = `Ruhs-Letter-${new Date().getTime()}.pdf`;
                const link = document.createElement('a');
                link.href = file_url;
                link.target = '_blank';
                link.download = fileName;
                document.body.appendChild(link);
                link.click();
            }
        } catch (error: any) {
            if (error.response) {
                //Spinner False and Set Toast
                setLoading(false);
                toast.current?.show({ severity: 'error', summary: 'Error', detail: 'Something Went Wrong' });
            }
        }
    };

    return (
        <>
            <LettersTab mainTabLabel="Verification Letters" />
            <VerificationTab initialTabLabel="RHUS Verification Letters" />
            <Toast ref={toast} />
            <div className="grid crud-demo mt-2">
                <div className="col-12">
                    <div className="card">
                        <div className="p-fluid formgrid grid align-items-center">
                            <div className="field col-12 md:col-4">
                                <label htmlFor="regNo">
                                    File No <span style={{ color: 'red' }}>*</span>
                                </label>
                                <InputText value={!window.cn(regNo) ? regNo : ''} name="regNo" keyfilter="num" autoComplete="off" placeholder="Enter File No." onChange={(e) => setRegNo(e.target.value)} className={errors['regNo'] && 'p-invalid'} />
                                <small className="p-invalid-txt">{errors['regNo']}</small>
                            </div>
                            <div className="field col-12 md:col-1 mt-4">
                                <Button label="Search" className="p-button-primary" onClick={() => getUserDetails()} loading={showLoading} />
                            </div>
                        </div>
                        <hr />
                        <div className="p-fluid formgrid grid">
                            <div className="field col-12 md:col-4">
                                <label htmlFor="Name">
                                    Name <span style={{ color: 'red' }}>*</span>
                                </label>
                                <InputText value={!window.cn(RHUsData?.Name) ? RHUsData?.Name : ''} name="Name" disabled={true} />
                            </div>
                            <div className="field col-12 md:col-4">
                                <label htmlFor="RollNo">
                                    Roll No <span style={{ color: 'red' }}>*</span>
                                </label>
                                <InputText
                                    value={!window.cn(RHUsData?.RollNo) ? RHUsData?.RollNo : ''}
                                    name="RollNo"
                                    autoComplete="off"
                                    placeholder="Enter Roll No"
                                    onChange={(e) => onInputChange(e, 'RollNo')}
                                    className={errors['RollNo'] && 'p-invalid'}
                                />
                                <small className="p-invalid-txt">{errors['RollNo']}</small>
                            </div>
                            <div className="field col-12 md:col-4">
                                <label htmlFor="PassYear">
                                    Passing Year <span style={{ color: 'red' }}>*</span>
                                </label>
                                <InputText value={!window.cn(RHUsData?.PassYear) ? RHUsData?.PassYear : ''} name="PassYear" disabled={true} />
                            </div>

                            <div className="field col-12 md:col-4">
                                <label htmlFor="DDNo">
                                    DD NO & Text
                                    <span style={{ color: 'red' }}>*</span>
                                </label>
                                <InputText value={!window.cn(RHUsData?.DDNo) ? RHUsData?.DDNo : ''} name="DDNo" autoComplete="off" placeholder="Enter DD Number" onChange={(e) => onInputChange(e, 'DDNo')} className={errors['DDNo'] && 'p-invalid'} />
                                <small className="p-invalid-txt">{errors['DDNo']}</small>
                            </div>
                            <div className="field col-12 md:col-4">
                                <label htmlFor="amount">
                                    Amount
                                    <span style={{ color: 'red' }}>*</span>
                                </label>
                                <InputText
                                    value={!window.cn(RHUsData?.amount) ? RHUsData?.amount : ''}
                                    name="amount"
                                    autoComplete="off"
                                    placeholder="Enter Amount"
                                    onChange={(e) => onInputChange(e, 'amount')}
                                    className={errors['amount'] && 'p-invalid'}
                                />
                                <small className="p-invalid-txt">{errors['amount']}</small>
                            </div>
                        </div>
                        <div className="formgrid grid">
                            <div className="field col-12 md:col-12">
                                <div style={{ display: 'flex', float: 'right', gap: 4 }}>
                                    <Button label="Clear" icon="pi pi-times" className="p-button-secondary mr-2" onClick={() => clearAll()} />
                                    <Button label="Save" icon="pi pi-check" onClick={() => addRHUsData()} loading={addLoader} disabled={buttonVisible} />
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="card">
                        <Toolbar left={leftToolbarTemplate} right={rightToolbarTemplate}></Toolbar>
                        {/* Datatable */}
                        {pageLoad ? (
                            <>
                                <DataTable
                                    value={RHUSList}
                                    showGridlines
                                    stripedRows
                                    globalFilter={globalFilter}
                                    filters={globalFieldFilter}
                                    onFilter={(e) => setGlobalFieldFilter(e.filters)}
                                    rows={defaultRowOptions}
                                    paginator={RHUSList.length >= 10 && true}
                                    rowsPerPageOptions={defaultPageRowOptions}
                                    className="datatable-responsive p-datatable-sm"
                                    emptyMessage="No Data Found"
                                    removableSort
                                >
                                    {AddRHUSLetterListColumns.map((col, i) => {
                                        if (col.field === 'action') {
                                            return <Column key={col.field} field={col.field} header={col.header} body={actionsTemplate} />;
                                        } else if (col.field === 'created_at') {
                                            return <Column key={col.field} field={col.field} header={col.header} body={dateTemplate} />;
                                        } else if (col.field === 'amount') {
                                            return <Column key={col.field} field={col.field} header={col.header} body={amountTemplate} />;
                                        } else {
                                            return <Column key={col.field} field={col.field} header={col.header} sortable filter filterPlaceholder={'Search by ' + col.header} />;
                                        }
                                    })}
                                </DataTable>
                            </>
                        ) : (
                            <>
                                {/* Skeleton Data table */}
                                <DataTable value={Skeletonitems}>
                                    {AddRHUSLetterListColumns.map((col, i) => (
                                        <Column key={col.field} field={col.field} header={col.header} body={SkeletonbodyTemplate} />
                                    ))}
                                </DataTable>
                            </>
                        )}
                    </div>
                </div>
            </div>

            {
                loading ? <Loader /> : ""
            }
        </>
    );
};
